import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Row, Col, } from 'antd';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { CSVLink } from 'react-csv';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';

const { Option } = Select;

function Import({ pageType, ColumData, RowData, name, callBack, Callback2, pageFrom, displayData, pdfData }) {
    const [fileName, setFileName] = useState()
    const [convertedTo, setConvertedTo] = useState('csv')
    const [form] = Form.useForm();
    const csvHeaders = ColumData?.map(col => col.exportTitle) ?? [];
    const csvKeys = ColumData?.map(col => col.key) ?? [];

    const csvData = [
        csvHeaders,
        ...((RowData ?? []).map(row =>
            csvKeys.map(key => row?.[key] ?? "")
        ))
    ];

    const updateFileName = (e) => {
        setFileName(e.target.value)
    };
    const updateFileType = (value) => {
        setConvertedTo(value)
    };
    useEffect(() => {
        if (pageFrom === "Report") {
            setFileName(`Grow-${name}`)
        }
         if (pageFrom === "Forcast") {
            setFileName(`Grow-${name}`)
        }
        else if (pageFrom === "Research") {
            setFileName(`Grow-Research-${displayData?.companyName}-${displayData?.companyDomain}`)
        }
        else {
            setFileName()
        }
    }, [pageFrom])
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const xlsxExtension = '.xlsx';
    const exportToXLSX = (inputData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(inputData);
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + xlsxExtension);
        if (pageType === "Download CSV") {
            callBack()
        }
        if (pageType === "Save CSV") {
            // save file
        }
    };
    const handleBlobCreate = async () => {
        const csvString = csvData.map(row =>
            row.map(item => `"${String(item).replace(/"/g, '""')}"`).join(',')
        ).join('\n');

        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const arrayBuffer = await blob.arrayBuffer();

        const buffer = {
            filename: `${fileName}.csv`,
            contentType: "text/csv",
            size: blob.size,
            contentDisposition: "attachment",
            content: {
                type: "Buffer",
                data: Array.from(new Uint8Array(arrayBuffer)),
            },
        };

        Callback2(name, buffer);
        callBack()
    };
    const handleDownload = async () => {
        const blob = new Blob([pdfData], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${fileName}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        callBack()
    };

    return (
        <>
            <AddUser>
                <div className="user-info-form">
                    <Form name="Export" form={form} colon={false}>
                        <BasicFormWrapper>
                            <div className="add-product-block">
                                <Row gutter={15}>
                                    <Col xs={24}>
                                        <div className="add-product-content">
                                            <Row gutter={30} style={{ padding: "0px 20px 20px" }}>
                                                <Col span={24} style={{ marginBottom: 20 }} >
                                                    <Form.Item label="File Name">
                                                        <Input placeholder="File Name" value={fileName} onChange={updateFileName} />
                                                    </Form.Item>
                                                </Col>
                                                {pageFrom === "Report" ? <Col span={24} >
                                                    <Form.Item label="File Type">
                                                        <Select onChange={updateFileType} value={convertedTo} disabled>
                                                            <Option value="csv">CSV</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col> : <></>}
                                            </Row>
                                            {(pageFrom === "Report"||pageFrom==="Forcast") ?
                                                <div className="form_action_button" style={{ padding: "0px 20px" }}>
                                                    {convertedTo === 'csv' ? (
                                                        pageType === "Save CSV" ?
                                                            <Button
                                                                className="button_colors" size="small" disabled={!fileName}
                                                                onClick={() => handleBlobCreate()}
                                                            >
                                                                <FeatherIcon icon="save" /> Save
                                                            </Button> :
                                                            pageType === "Download CSV" ?
                                                                !fileName ?
                                                                    <Button size="small" className="button_colors" disabled={!fileName}>
                                                                        <FeatherIcon icon="download-cloud" /> Download
                                                                    </Button> :
                                                                    <CSVLink filename={`${fileName}.csv`} data={csvData}
                                                                        onClick={() => callBack()}
                                                                    >
                                                                        <Button size="small" className="button_colors" disabled={!fileName}>
                                                                            <FeatherIcon icon="download-cloud" /> Download
                                                                        </Button>
                                                                    </CSVLink> : ""
                                                    ) : (
                                                        <Button disabled={!fileName}
                                                            className="button_colors" size="small"
                                                            onClick={() => exportToXLSX(csvData, fileName)}
                                                        >
                                                            <FeatherIcon icon="download-cloud" /> Download
                                                        </Button>
                                                    )}
                                                </div> :
                                                <div className="form_action_button" style={{ padding: "0px 20px" }}>
                                                    <Button
                                                        className="button_colors" size="small" disabled={!fileName}
                                                        onClick={() => handleDownload()}
                                                    >
                                                        <FeatherIcon icon="download" /> Download PDF
                                                    </Button>
                                                </div>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </BasicFormWrapper>
                    </Form>
                </div>
            </AddUser>
        </>
    );
}
Import.propTypes = {
    pageType: PropTypes.string.isRequired,
    ColumData: PropTypes.array.isRequired,
    RowData: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    callBack: PropTypes.func.isRequired,
    Callback2: PropTypes.func.isRequired,
    pageFrom: PropTypes.string.isRequired,
    displayData: PropTypes.object.isRequired,
    pdfData: PropTypes.string.isRequired,
};
export default Import;